var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 11.3588C20.3137 10.9542 20.4 10.5118 20.4 10.0504C20.4 8.04622 18.7875 6.42017 16.8 6.42017C16.0613 6.42017 15.3713 6.64706 14.8013 7.03277C13.7625 5.21765 11.8238 4 9.6 4C6.285 4 3.6 6.70756 3.6 10.0504C3.6 10.1525 3.60375 10.2546 3.6075 10.3567C1.5075 11.1017 0 13.121 0 15.4958C0 18.5021 2.41875 20.9412 5.4 20.9412H19.2C21.8513 20.9412 24 18.7744 24 16.1008C24 13.7601 22.35 11.805 20.16 11.3588ZM14.7525 13.6807H12.3V17.916C12.3 18.2487 12.03 18.521 11.7 18.521H9.9C9.57 18.521 9.3 18.2487 9.3 17.916V13.6807H6.8475C6.31125 13.6807 6.045 13.0303 6.42375 12.6483L10.3763 8.66261C10.6088 8.42815 10.9913 8.42815 11.2238 8.66261L15.1763 12.6483C15.555 13.0303 15.285 13.6807 14.7525 13.6807Z",
    fill: "#6363FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.08fa34d36e5ddfb093e8d38108fce1bf.svg";
export { ForwardRef as ReactComponent };